var Gallery = (function () {


  var $galleries;
  var $hoverTriggers;
  var $tabs;
  var $grids;
  var maxFirstRowThumbs;
  var maxSecondRowThumbs;
  var maxThirdRowThumbs;
  var isLazyLoading;
  var debounce;

  var batchSize = 10;
  var maxColumns = 36;
  var aspectRatio = 16 / 9;
  var pendingImages = 0;
  var currentBatchSize = 0;
  var layingOut = false;

  function init(options) {
    if (options && options.batchSize) {
      batchSize = options.batchSize;
    }

    if ($('.acr-gallery').length) {
      $('.acr-gallery').find('.grid').css('visibility', 'hidden');
      layout();
      loadImages();
      attachHover();
      attachResize();
      attachCloseModal();
      attachClick();
      attachTransitionEnd();
    }
  }

  function layout() {
    if (layingOut) {
      return;
    }

    pendingImages = 0;
    layingOut = true;
    $galleries = $('.acr-gallery');

    if (window.innerWidth < Constants.breakpoints.sm) {
      maxFirstRowThumbs = 2;
      maxSecondRowThumbs = 1;
      isLazyLoading = false;
    } else {
      maxFirstRowThumbs = 3;
      maxSecondRowThumbs = 2;
      maxThirdRowThumbs = 1;
      isLazyLoading = false;
    }


    $galleries.each(function (i, gallery) {
      var currentThumbs;
      var $gallery = $(gallery);
      var filters = $gallery.data('filter') || '';
      var thumbs = [];
      var thumbImages = [];

      filters = filters.split('|');

      $.each(filters, function (i, filter) {
        filter = filter ? '*=' + filter : '';

        var partialThumbs = $gallery.find(
          '.thumb:has(".thumb-content[data-type'
          + filter + ']")',
        );
        var partialThumbImages = $gallery.find('.thumb-content[data-type'
          + filter + ']');
        $.merge(thumbs, partialThumbs);
        $.merge(thumbImages, partialThumbImages);
      });

      var rowType = 1;
      var animDelay = 0;
      var galleryWidth = $gallery.width();

      while (thumbs.length > 0) {
        if (rowType === 1 && thumbs.length >= maxFirstRowThumbs) {
          currentThumbs = thumbs.splice(0, maxFirstRowThumbs);
        } else if (rowType === 2 && thumbs.length >= maxSecondRowThumbs) {
          currentThumbs = thumbs.splice(0, maxSecondRowThumbs);
        } else if (rowType === 3 && thumbs.length >= maxThirdRowThumbs) {
          currentThumbs = thumbs.splice(0, maxThirdRowThumbs);
        } else {
          currentThumbs = thumbs;
          thumbs = [];
        }

        var height = 0;
        var width = 0;

        $.each(currentThumbs, function (i, thumb) {
          var numCols = maxColumns / currentThumbs.length;
          var $thumb = $(thumb);
          animDelay += 0.1;

          $thumb.removeClass();
          $thumb.addClass('thumb visible col-xs-' + numCols);

          if (width === 0) {
            width = Math.floor(galleryWidth / currentThumbs.length);
          }

          if (height === 0) {
            height = Math.round(width / aspectRatio);
          }

          $thumb.find('.thumb-content').height(height)
            .attr('data-colspan', rowType);
          $thumb.width(width);
        });

        if (window.innerWidth < Constants.breakpoints.sm) {
          rowType = (rowType === 1) ? 2 : 1;
        } else {
          rowType = (rowType === 3) ? 1 : rowType + 1;
        }
      }

      pendingImages += thumbImages.length;
    });

    layingOut = false;
  }


  function addBackgroundLazyLoading(element) {
    var elemenImageType;
    var currentBreakpoint;
    var currentImage;
    var img;

    elemenImageType = element.dataset.colspan;
    currentBreakpoint = Utility.getCurrentBreakpoint().breakpoint;

    currentImage = 'img' + currentBreakpoint.charAt(0).toUpperCase()
    + currentBreakpoint.slice(1)
    + 'C'
    + elemenImageType;

    img = element.dataset[currentImage];
    element.style.backgroundImage = 'url("' + img + '")';
  }

  function loadImages() {
    var thumbs = $('.acr-gallery .thumb-content:not(.shown)');

    for (var i = 0; i < currentBatchSize; i++) {
      $(thumbs[i]).addClass('acr-responsive-background-behaviorIO')
        .data('type', 'Gallery/imageLoad');
    }

    Utility.initLazyLoadingIO([].slice.call(thumbs), addBackgroundLazyLoading);

  }

  function switchImages() {
    var elemenImageType;
    var currentBreakpoint;
    var currentImage;
    var thumbs;
    var img;

    currentBreakpoint = Utility.getCurrentBreakpoint().breakpoint;
    thumbs = $('.acr-gallery .thumb-content:not(.shown)');

    [].slice.call(thumbs).forEach(function (element) {
      elemenImageType = element.dataset.colspan;

      currentImage = 'img' + currentBreakpoint.charAt(0).toUpperCase()
      + currentBreakpoint.slice(1)
      + 'C'
      + elemenImageType;

      img = element.dataset[currentImage];
      element.style.backgroundImage = 'url("' + img + '")';
    });

  }

  function attachHover() {
    $hoverTriggers = $('.acr-gallery .play,'
      + '.acr-gallery .rollover-bg,'
      + '.acr-gallery .acr-icon-direction-45');

    $hoverTriggers.off('hover');

    $hoverTriggers.hover(function () {
      $(this).siblings('.thumb-content')
        .addClass('hover');
    }, function () {
      $(this).siblings('.thumb-content')
        .removeClass('hover');
    });
  }

  function attachResize() {
    $(window).off('resize', onResize);
    $(window).resize(onResize);

    setTimeout(function () {
      layout();
      $('.acr-gallery .grid').css('visibility', 'visible');
    }, 250);
  }

  function onResize() {

    clearTimeout(debounce);
    debounce = setTimeout(function () {
      layout();
      switchImages();
      $('.acr-gallery .grid').css('visibility', 'visible');
    }, 250);
  }

  function attachCloseModal() {
    $(window).on('ar.closemodal', layout);
  }

  function attachClick() {
    $tabs = $('.acr-gallery .tab a');

    $tabs.on('click', function () {
      var left;
      var $this = $(this);
      var $container = $this.parents('.tabs');
      var $gallery = $this.parents('.acr-gallery');

      var type = $this.data('type');
      var filter = (type === 'all') ? '' : type;

      $gallery.data('filter', filter);

      $container.find('.tab-content').removeClass('active');
      $gallery.find('.grid')
        .addClass('fade-out')
        .css('visibility', 'hidden')
        .trigger('webkitTransitionEnd');

      $this.parent().addClass('active');
      setTimeout(function () {
        layout();
        $gallery.find('.grid').css('visibility', 'visible');
      }, 250);
    });
  }

  function attachTransitionEnd() {
    $grids = $('.acr-gallery .grid');

    $grids.each(function (i, grid) {
      var event = 'webkitTransitionEnd otransitionend oTransitionEnd '
          + 'msTransitionEnd transitionend';
      $(grid).on(event, function () {
        var $this = $(this);

        if ($this.hasClass('fade-out') && $this.hasClass('grid')) {
          $this.parents('.acr-gallery').find('.thumb').removeClass()
            .addClass('thumb');
          pendingImages = 0;
          currentBatchSize = 0;

          layout();

          $this.removeClass('fade-out');
        }
      });
    });
  }

  $(document).off('Gallery/imageLoad')
    .on('Gallery/imageLoad', function (e, imageSrc) {
      if (isLazyLoading) {
        currentBatchSize -= 1;
        pendingImages -= 1;

        if (currentBatchSize === 0) {
          loadImages();
        }
      }
    });

  return {
    init: init,
  };
}());
